module.exports = __webpack_public_path__ + "carousel_04_img_03.png?d6b20c95715b0ca466199097f1fbf143";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel_04_img_03.png
// module id = 158
// module chunks = 0